import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Typography, useTheme } from '@mui/material';
import Accordion from 'app/shared/components/common/Accordion';
import PropType from 'prop-types';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getStyles } from '../../../Activities.styles';
import HighlightText from '../../../HighlightText';

const CallTranscription = ({ id, transcription }) => {
  const theme = useTheme();
  const classes = getStyles(theme);

  const highlightText = useSelector(getDebouncedSearchValue);

  return (
    <Accordion
      bottom={
        <div className="whitespace-pre-line mb-16">
          <HighlightText highlight={highlightText} text={transcription} />
        </div>
      }
      className="overflow-hidden shadow-none"
      defaultExpanded={false}
      id={`call-${id}-transcription`}
      isWithDivider={false}
      sx={classes.accordion}
      top={
        <Typography className="ml-20" variant="regular14">
          Transcription
        </Typography>
      }
    />
  );
};

CallTranscription.propTypes = {
  id: PropType.string.isRequired,
  transcription: PropType.string.isRequired,
};

export default memo(CallTranscription);
